import { captureException } from '@sentry/browser';
import { useEffect, lazy, Suspense } from 'react';
import { useRouteError } from 'react-router-dom';

import { ScreenLoader } from '../ScreenLoader';

const LazyError = lazy(() => import('../Error'));

export const RouterError = () => {
  const error = useRouteError();

  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <Suspense fallback={<ScreenLoader />}>
      <LazyError />
    </Suspense>
  );
};